import { HttpErrorResponse } from "@angular/common/http";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { AlertController, Events, ModalController } from "ionic-angular";
import { ClearinghouseApiProfile } from "../../../models/payers/payer";
import { PayersService } from "../../../providers/payers-service/payers.service";
import { UtilityService } from "../../../providers/utility-service/utility-service";
import { NgbCustomParserFormatter } from "../../common/date-picker/ngb-custom-parser-formatter";
import { SharedEligibilityService } from "./shared-eligibility";

@Component({
  selector: "payer-eligibility",
  templateUrl: "eligibility.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PayerEligibility),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PayerEligibility),
      multi: true,
    },
    { provide: NgbDateParserFormatter, useClass: NgbCustomParserFormatter },
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class PayerEligibility implements OnInit, OnChanges {
  @Input() currentPayer: any;
  @Input() showInstantEligibility: boolean = false;
  @Input() showScheduledEligibility: boolean = false;
  @Output() onPayerEligibilitySaved = new EventEmitter<any>();
  @Output() onCanceled = new EventEmitter<any>();
  saveEnabled: boolean = false;
  editMode: boolean = false;
  chkDisabled: boolean = false;
  scheduleEligibility: boolean = false;
  payer: any;
  selectedTab: string = "BATCHELIGIBILITY";
  filteredData: any = [];
  totalLength = 0;
  update = false;

  clearinghouseApiUserList: any[] = [];
  selectedClearinghouseId: string = "None";
  instantSaveEnabled: boolean = false;
  scheduleEligibilityFrequency: string;
  scheduleEligibilityFrequencyUnit: string;
  scheduleReceiverId: string;
  instantReceiverId: string;

  monthDays: any[] = [
    { name: "1st", value: "1st" },
    { name: "2nd", value: "2nd" },
    { name: "3rd", value: "3rd" },
    { name: "4th", value: "4th" },
    { name: "5th", value: "5th" },
    { name: "6th", value: "6th" },
    { name: "7th", value: "7th" },
    { name: "8th", value: "8th" },
    { name: "9th", value: "9th" },
    { name: "10th", value: "10th" },
    { name: "11th", value: "11th" },
    { name: "12th", value: "12th" },
    { name: "13th", value: "13th" },
    { name: "14th", value: "14th" },
    { name: "15th", value: "15th" },
    { name: "16th", value: "16th" },
    { name: "17th", value: "17th" },
    { name: "18th", value: "18th" },
    { name: "19th", value: "19th" },
    { name: "20th", value: "20th" },
    { name: "21st", value: "21st" },
    { name: "22nd", value: "22nd" },
    { name: "23rd", value: "23rd" },
    { name: "24th", value: "24th" },
    { name: "25th", value: "25th" },
    { name: "26th", value: "26th" },
    { name: "27th", value: "27th" },
    { name: "28th", value: "28th" },
  ];

  constructor(
    private fb: FormBuilder,
    private payersService: PayersService,
    private utilityService: UtilityService,
    protected alertController: AlertController,
    public modalCtrl: ModalController,
    public sharedEligibility: SharedEligibilityService,
    public event: Events
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.initializeInstantEligibility();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initForm();
  }

  initForm() {
    if (this.showScheduledEligibility) {
      this.selectedTab = "BATCHELIGIBILITY";
    } else if (this.showInstantEligibility) {
      this.selectedTab = "INSTANTELIGIBILITY";
    }

    this.setValue(this.currentPayer);
    if (this.currentPayer && this.currentPayer.scheduleEligibility) {
      this.onPayerEligibilitySaved.emit();
    }

    this.event.subscribe("currentData", (data) => {
      if (data && data.eligibilityUpdated) {
        this.chkDisabled = false;
        this.update = false;
        this.currentPayer = data;
        this.setValue(data);
      }
    });
  }

  setValue(data) {
    this.filteredData = [];
    if (this.currentPayer) {
      this.totalLength = this.currentPayer.benefitType.split(",").length;
      let index = 0;
      this.currentPayer.benefitType.split(",").forEach((t) => {
        t = t.replace(/ /g, "");
        t = t.toUpperCase();
        if (
          this.currentPayer &&
          this.currentPayer.claimRules &&
          this.currentPayer.claimRules.edi &&
          this.currentPayer.claimRules.edi.length > 0
        ) {
          let dataFiltered = this.currentPayer.claimRules.edi.filter(
            (x) => x.benefitType == t
          )[0];
          if (dataFiltered) {
            this.filteredData.push(dataFiltered);
          }
        }
        index++;

        if (this.totalLength == index) {
          this.enableDisableCheckBox();
          data.eligibilityUpdated = false;
        }
      });
    }
  }

  enableDisableCheckBox() {
    if (this.filteredData.length > 0) {
      let value = this.filteredData.filter(
        (x) => x.clearinghouseId != "0" && x.clearinghouseId != ""
      ).length;

      if (value == 0) {
        this.chkDisabled = true;
        this.scheduleEligibility = false;
        this.scheduleReceiverId = "";
        this.scheduleEligibilityFrequency = "";
        this.scheduleEligibilityFrequencyUnit = "";
        this.update = true;
        this.saveEligibility(this.update);
      } else {
        this.chkDisabled = false;
        this.scheduleEligibility = this.currentPayer.scheduleEligibility;
        if (this.scheduleEligibility) {
          this.scheduleReceiverId = this.currentPayer.scheduleReceiverId;
          this.scheduleEligibilityFrequency =
            this.currentPayer.scheduleFrequency;
          this.scheduleEligibilityFrequencyUnit =
            this.currentPayer.scheduleFrequencyUnit;
        }
      }
    } else {
      this.scheduleEligibility = false;
      this.scheduleReceiverId = "";
      this.scheduleEligibilityFrequency = "";
      this.scheduleEligibilityFrequencyUnit = "";
      this.chkDisabled = true;
      this.update = true;
      this.saveEligibility(this.update);
    }
  }

  cancel(): void {
    this.onCanceled.emit(true);
  }

  saveEligibility(update) {
    let benefitTypeValues = this.payersService.normalizePayerDataForSave(
      this.currentPayer.benefitType
    );

    let value = {
      payerId: this.currentPayer.payerId,
      tenantId: this.currentPayer.tenantId,
      payerName: this.currentPayer.payerName,
      payerType: this.currentPayer.payerType.toUpperCase(),
      benefitType: benefitTypeValues,
      plans: this.currentPayer.plans,
      payerAddress: this.currentPayer.payerAddress,
      contactNumber: this.currentPayer.contactNumber,
      useSameAddress: this.currentPayer.useSameAddress,
      payToAddress: this.currentPayer.payToAddress,
      scheduleEligibility: this.scheduleEligibility,
      scheduleFrequency: this.scheduleEligibilityFrequency,
      scheduleReceiverId: this.scheduleReceiverId,
      scheduleFrequencyUnit: this.scheduleEligibilityFrequencyUnit,
      scheduleUpdatedDate: this.getCurrentDate(),
      instantReceiverId: this.currentPayer?.instantReceiverId ?? null,
      instantEligibilityClearinghouseId:
        this.currentPayer?.instantEligibilityClearinghouseId ?? null,
      isActive: true,
    };
    this.update = update;
    this.showSavePayerModal(value);
  }

  getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  showSavePayerModal(payer) {
    if (this.update == false) {
      let modalPage = this.modalCtrl.create(
        "SaveFacilityPage",
        {
          title: "Payer Information Change",
          commentPlaceholderKey: "archiveFacilityCommentPlaceHolder",
          popupMessageKey: "savePayerWarningMessage",
          section: "payer",
        },
        {
          enableBackdropDismiss: false,
          cssClass: "save-payer-confirmation-popup",
        }
      );
      modalPage.onDidDismiss((data) => {
        if (data.save) {
          this.savePayerDetails(payer, "Updating Payer ...");
        }
      });
      modalPage.present();
    } else {
      this.savePayerDetails(payer, "updating data");
    }
  }

  savePayerDetails(payer, spinnerMessage) {
    if (this.update == false) {
      this.utilityService.increaseSpinnerCount(spinnerMessage);
    }
    this.payersService
      .savePayerDetails(payer)
      .pipe()
      .take(1)
      .subscribe((data) => {
        this.currentPayer.scheduleEligibility = this.scheduleEligibility;
        if (this.currentPayer.scheduleEligibility) {
          this.currentPayer.scheduleFrequency =
            this.scheduleEligibilityFrequency;
          this.currentPayer.scheduleFrequencyUnit =
            this.scheduleEligibilityFrequencyUnit;
          this.currentPayer.scheduleReceiverId = this.scheduleReceiverId;
        }
        if (payer.instantEligibilityClearinghouseId !== undefined) {
          let clearinghouseId =
            this.selectedClearinghouseId === "None"
              ? null
              : parseInt(this.selectedClearinghouseId, 10);
          this.currentPayer.instantEligibilityClearinghouseId = clearinghouseId;
          this.currentPayer.instantReceiverId = this.instantReceiverId;
        }

        this.onSaveSuccessAlert();
      }, this.onSaveError);
  }

  checkBoxClick() {
    if (this.scheduleEligibility == false) {
      this.scheduleReceiverId = "";
      this.scheduleEligibilityFrequency = "";
      this.scheduleEligibilityFrequencyUnit = "";
    } else {
      if (
        !this.currentPayer.scheduleFrequency &&
        !this.currentPayer.scheduleFrequencyUnit
      ) {
        this.scheduleEligibilityFrequency = "weekly";
        this.scheduleEligibilityFrequencyUnit = "wednesday";
      } else {
        this.scheduleReceiverId = this.currentPayer.scheduleReceiverId;
        this.scheduleEligibilityFrequency = this.currentPayer.scheduleFrequency;
        this.scheduleEligibilityFrequencyUnit =
          this.currentPayer.scheduleFrequencyUnit;
      }
    }
    this.checkValue();
  }

  checkValue() {
    this.saveEnabled = false;
    if (!this.scheduleEligibility) {
      this.saveEnabled = true;
    } else if (
      this.scheduleEligibility &&
      this.scheduleEligibilityFrequency &&
      this.scheduleEligibilityFrequencyUnit &&
      this.scheduleReceiverId
    ) {
      this.saveEnabled = true;
    }
  }

  showAlert = ({ title, message }) => {
    let alert = this.alertController.create({
      title,
      message,
      buttons: [
        {
          text: "Ok",
        },
      ],
    });
    alert.present();
  };

  private onSaveSuccessAlert = () => {
    this.saveEnabled = false;
    if (this.selectedTab === "INSTANTELIGIBILITY") {
      this.instantSaveEnabled = false;
    }
    if (this.update == false) {
      this.showAlert({
        title: "Success",
        message: "Payer Eligibility Saved",
      });
      this.utilityService.decreaseSpinnerCount();
    }
    this.onPayerEligibilitySaved.emit();
  };

  private onSaveError = (error) => {
    this.saveEnabled = true;
    if (this.selectedTab === "INSTANTELIGIBILITY") {
      this.instantSaveEnabled = true;
    }
    if (this.update == false) {
      this.utilityService.decreaseSpinnerCount();
      if (error instanceof HttpErrorResponse) {
        if (error.error) {
          this.showAlert({
            title: "Error",
            message: error.error.message,
          });
        } else {
          this.showAlert({
            title: "Error",
            message: "Error while saving Eligibility info. " + error.message,
          });
        }
      }
    }
  };

  initializeInstantEligibility(): void {
    if (
      this.currentPayer &&
      this.currentPayer.instantEligibilityClearinghouseId &&
      this.currentPayer.instantEligibilityClearinghouseId !== null &&
      this.currentPayer.instantEligibilityClearinghouseId !== ""
    ) {
      this.selectedClearinghouseId =
        this.currentPayer.instantEligibilityClearinghouseId.toString();
      this.instantReceiverId = this.currentPayer.instantReceiverId;
    } else {
      this.selectedClearinghouseId = "None";
      this.instantReceiverId = "";
    }

    this.loadClearinghouseApiUsers();
  }

  loadClearinghouseApiUsers(): void {
    this.clearinghouseApiUserList = [{ name: "None", value: "None" }];

    this.payersService.getClearinghouseApiProfiles().subscribe(
      (data: ClearinghouseApiProfile[]) => {
        this.clearinghouseApiUserList = [{ name: "None", value: "None" }];

        if (data && data.length > 0) {
          data.forEach((profile) => {
            if (profile.clearinghouseApiUsername) {
              this.clearinghouseApiUserList.push({
                name: profile.clearinghouseApiUsername,
                value: profile.clearinghouseId.toString(),
              });
            }
          });
        }

        this.restoreSavedSelection();
      },
      (error) => {
        console.warn("Clearinghouse API profiles not available:", error);
        this.clearinghouseApiUserList = [{ name: "None", value: "None" }];
      }
    );
  }

  restoreSavedSelection(): void {
    if (
      this.currentPayer &&
      this.currentPayer.instantEligibilityClearinghouseId &&
      this.currentPayer.instantEligibilityClearinghouseId !== null &&
      this.selectedClearinghouseId === "None"
    ) {
      const savedValue =
        this.currentPayer.instantEligibilityClearinghouseId.toString();
      const validOption = this.clearinghouseApiUserList.find(
        (option) => option.value === savedValue
      );
      if (validOption) {
        this.selectedClearinghouseId = savedValue;
      }
    }
  }

  onClearinghouseApiUserChange(): void {
    this.instantSaveEnabled = false;
    if (this.selectedClearinghouseId === "None") {
      this.instantReceiverId = "";
      this.instantSaveEnabled = true;
    } else if (
      this.selectedClearinghouseId !== "None" &&
      this.instantReceiverId
    ) {
      this.instantSaveEnabled = true;
    }
  }

  saveInstantEligibility(): void {
    let clearinghouseId =
      this.selectedClearinghouseId === "None"
        ? null
        : parseInt(this.selectedClearinghouseId, 10);

    let benefitTypeValues = this.payersService.normalizePayerDataForSave(
      this.currentPayer.benefitType
    );

    let value = {
      payerId: this.currentPayer.payerId,
      tenantId: this.currentPayer.tenantId,
      payerName: this.currentPayer.payerName,
      payerType: this.currentPayer.payerType.toUpperCase(),
      benefitType: benefitTypeValues,
      plans: this.currentPayer.plans,
      payerAddress: this.currentPayer.payerAddress,
      contactNumber: this.currentPayer.contactNumber,
      useSameAddress: this.currentPayer.useSameAddress,
      payToAddress: this.currentPayer.payToAddress,
      scheduleEligibility: this.currentPayer.scheduleEligibility,
      scheduleFrequency: this.currentPayer.scheduleFrequency,
      scheduleReceiverId: this.currentPayer.scheduleReceiverId,
      scheduleFrequencyUnit: this.currentPayer.scheduleFrequencyUnit,
      scheduleUpdatedDate: this.currentPayer.scheduleUpdatedDate,
      instantEligibilityClearinghouseId: clearinghouseId,
      instantReceiverId: this.instantReceiverId,
      isActive: true,
    };
    this.update = false;
    this.showSavePayerModal(value);
  }

  changeTab(tabName) {
    this.selectedTab = tabName;

    if (tabName === "INSTANTELIGIBILITY") {
      this.loadClearinghouseApiUsers();
    }
  }

  enableFrequencyUnit(data) {
    this.scheduleEligibilityFrequencyUnit = null;
    this.scheduleEligibilityFrequency = data;
    this.checkValue();
  }
}



// WEBPACK FOOTER //
// ./src/components/payers/eligibility/eligibility.ts